"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWindowTypeDropdownComponent = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var configurationStyles_1 = require("../configurationStyles");
var DateWindowComponent_1 = require("./DateWindowComponent");
var DateWindowTypeDropdownComponent = function (props) {
    var listItemsWithWindow = [];
    var _a = React.useState(''), displayName = _a[0], setDisplayName = _a[1];
    React.useEffect(function () {
        var _a;
        if (!props.isCustomWindowSelected) {
            var defaultWindowForGranularity = (0, metrics_engine_1.defaultDateWindow)(props.dateTrunc);
            var selectedDateWindow = (_a = props.selectedDateWindow) !== null && _a !== void 0 ? _a : defaultWindowForGranularity;
            setDisplayName((0, metrics_engine_1.displayDateWindow)(selectedDateWindow));
            if (!(0, DateWindowComponent_1.windowsMatch)(props.selectedDateWindow, selectedDateWindow)) {
                props.onChange(selectedDateWindow);
            }
        }
        else {
            setDisplayName(Localize_1.Messages.CustomOption());
        }
    }, [props.selectedDateWindow]);
    var updateStateValue = function (value) {
        var _a, _b;
        var window = (_b = (_a = listItemsWithWindow.find(function (item) { return item.value === value; })) === null || _a === void 0 ? void 0 : _a.window) !== null && _b !== void 0 ? _b : null;
        props.setCustomWindowSelected(value === Localize_1.Messages.CustomOption());
        props.onChange(window);
    };
    var getDateWindowDisplayList = function () {
        var dateWindows = (0, metrics_engine_1.dateWindowOptions)(props.dateTrunc);
        listItemsWithWindow = dateWindows.map(function (dateWindow) { return ({
            value: (0, metrics_engine_1.displayDateWindow)(dateWindow),
            window: dateWindow,
        }); });
        listItemsWithWindow = listItemsWithWindow.concat({
            value: Localize_1.Messages.CustomOption(),
        });
        return listItemsWithWindow;
    };
    return (React.createElement(widgets_1.SingleSelectDropdown, __assign({}, {
        className: configurationStyles_1.inputSection,
        testId: props.testId,
        type: widgets_1.DropdownButtonType.Outline,
        label: Localize_1.Messages.DateRange(),
        list: React.createElement(widgets_1.List, { items: getDateWindowDisplayList() }),
        onChange: updateStateValue,
        value: displayName,
        disabled: props.disabled,
        buttonRef: props.dropdownRef,
    })));
};
exports.DateWindowTypeDropdownComponent = DateWindowTypeDropdownComponent;
//# sourceMappingURL=DateWindowTypeDropdownComponent.js.map